import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '@core/services/auth.service';

export const loginCanMatch: CanMatchFn = async (): Promise<
  boolean | UrlTree
> => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  await (auth as any).waitStorageReady?.();

  const session = await auth.safeFetchAuthSession?.();
  const logged = !!session?.tokens?.idToken;

  if (!logged) return true;
  return router.createUrlTree(['/home']);
};
